import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useTheme } from "@/context/ThemeContext";
import ThemePicker from "@/components/dashboard/ThemePicker";

/** Per-device appearance: Default (Light / Dark) or Orange. */
const ThemeSettingsDialog = ({ open, onOpenChange }) => {
  const { theme, setTheme } = useTheme();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto bg-[#0d0d0d] text-white sm:max-w-md" data-testid="theme-settings-dialog">
        <DialogHeader>
          <DialogTitle>Theme</DialogTitle>
          <DialogDescription className="text-white/50">Choose how the portal looks on this device.</DialogDescription>
        </DialogHeader>
        <div className="pt-2">
          <ThemePicker value={theme} onPick={setTheme} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ThemeSettingsDialog;
